import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { href: "/events?period=ongoing" }
const _hoisted_3 = { href: "/events?period=this-week" }
const _hoisted_4 = { href: "/events?period=this-weekend" }
const _hoisted_5 = { href: "/events?period=this-month" }
const _hoisted_6 = { href: "/events?period=next-month" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 2,
  class: "area-select-wrapper"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["href"]

import { ref } from 'vue';
import { areas as areaList } from '@/js/data/area';
import genreList from '@/js/data/genre';


export default /*@__PURE__*/_defineComponent({
  __name: 'find-events',
  setup(__props) {

const activeTab = ref<string>();
const activeArea = ref<string>();
const labelObj = {
  ongoing: '開催中',
  'this-week': '今週',
  'this-weekend': '今週末',
  'this-month': '今月',
  'next-month': '来月以降',
};
const periodLabel = (period: keyof typeof labelObj) => labelObj[period] || '';
const onClickMenu = (item: string) => {
  activeTab.value = activeTab.value === item ? undefined : item;
};
const onClickArea = (area: string) => {
  activeArea.value = activeArea.value === area ? undefined : area;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.findEvents)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.findEventsMenu, activeTab.value ? _ctx.$style.active : ''])
    }, [
      _createElementVNode("a", {
        class: _normalizeClass([activeTab.value === 'period' ? _ctx.$style.selected : '']),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onClickMenu('period')), ["prevent"]))
      }, "開催日", 2),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createElementVNode("a", {
        class: _normalizeClass([activeTab.value === 'genre' ? _ctx.$style.selected : '']),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onClickMenu('genre')), ["prevent"]))
      }, "ジャンル", 2),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createElementVNode("a", {
        class: _normalizeClass([activeTab.value === 'area' ? _ctx.$style.selected : '']),
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onClickMenu('area')), ["prevent"]))
      }, "エリア", 2)
    ], 2),
    _cache[12] || (_cache[12] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.findEventsContent)
    }, [
      (activeTab.value === 'period')
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_2, _toDisplayString(periodLabel('ongoing')), 1)
            ]),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_3, _toDisplayString(periodLabel('this-week')), 1)
            ]),
            _cache[6] || (_cache[6] = _createTextVNode()),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_4, _toDisplayString(periodLabel('this-weekend')), 1)
            ]),
            _cache[7] || (_cache[7] = _createTextVNode()),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_5, _toDisplayString(periodLabel('this-month')), 1)
            ]),
            _cache[8] || (_cache[8] = _createTextVNode()),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_6, _toDisplayString(periodLabel('next-month')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[10] || (_cache[10] = _createTextVNode()),
      (activeTab.value === 'genre')
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(genreList), (genre) => {
              return (_openBlock(), _createElementBlock("li", {
                key: genre.slug
              }, [
                _createElementVNode("a", {
                  href: `/events?genre=${genre.slug}`
                }, _toDisplayString(genre.name), 9, _hoisted_8)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _cache[11] || (_cache[11] = _createTextVNode()),
      (activeTab.value === 'area')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(areaList), (area) => {
              return (_openBlock(), _createElementBlock("section", {
                key: area.slug
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass([activeArea.value === area.slug ? _ctx.$style.selected : '']),
                  onClick: _withModifiers(($event: any) => (onClickArea(area.slug)), ["prevent"])
                }, _toDisplayString(area.name), 11, _hoisted_10),
                _cache[9] || (_cache[9] = _createTextVNode()),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.prefectures)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(area.prefectures, (p) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: p.slug,
                      href: `/events?prefecture=${p.slug}`
                    }, _toDisplayString(p.name), 9, _hoisted_11))
                  }), 128))
                ], 2)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})